import styles from "../../pages/tnpsc-admissions/tnpsc-admissions.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import { prelimshallticket } from "../Service/hallticketvalidate";
import Otpverification from "../Modal/Otpverification";
import { useState } from "react";
import Link from "next/link";

    const Upsc_Prelims_form = () => {
    const [verified, setverified] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalOtp, setModalOtp] = useState(false);
    const [modalOtpstatus, setmodalOtpstatus] = useState(null);
    const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
    const [valuephno, setvaluephno] = useState(undefined);
    const [captchaerror, setcaptchaerror] = useState(undefined);
    const [pdferror, setpdferror] = useState(undefined);
     function convertJsonStringToNumber(jsonString) {
        // Parse the JSON string to an object
        const jsonObject = JSON.parse(jsonString);
      
        // Iterate over the keys and convert numeric strings to numbers
        for (const key in jsonObject) {
          if (jsonObject.hasOwnProperty(key)
    && !isNaN(jsonObject[key])) {
            jsonObject[key] = Number(jsonObject[key]);
          }
        }
      
        return jsonObject;
      }
      function onChange(value) {
        if (value == null) {
          setverified(false);
        }
        else {
          setverified(true);
        }
      }
  
  function onChange(value) {
    if (value == null) {
      setverified(false);
    }
    else {
      setverified(true);
    }
  }

  function onChange(value) {
    const fup = document.getElementById('pdfid');
     const fileName = fup.value;
    const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
    if (value == null ) {
      setverified(false);
    }
    else 
    {
      setverified(true);
    }
  }

  const [base64PdfToUpload, setbase64PdfToUpload] = useState();

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

   const uploadDocument = async (event, type) => {
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    const updloadFile = {
      "name": file.name,
      "type": file.type,
      "content": base64.split(",")[1],
      "base64": base64
    }
    if (type == "image") {
      setbase64ImageToUpload(updloadFile);
    } else if (type == "pdf") {
      setbase64PdfToUpload(updloadFile);
    }
  };

  const pdfUpload = (e) => {
    if ((e.target.files[0].size / 1024) <= 2048) {
      document.getElementById("selectpdf").value = e.target.files[0].name;
      uploadDocument(e, "pdf");
    }
    else {
      setpdferror(true);
      setTimeout(() => {
        setpdferror(false);
      }, 3000);

      document.getElementById("pdfid").value = "";

    }

  };

  async function handleOnSubmit(e) {
    e.preventDefault();
    if (verified) {
      const formData = {};
      formData['formType'] = "Upschallticketvalidation";
      formData['title'] = "Upsc HallTicket validation 2025";
      Array.from(e.currentTarget.elements).forEach(field => {
        if (!field.name) return;
        formData[field.name] = field.value;
      });
      //formData['countryCode'] = "+91";
      formData["pdfFile"] = base64PdfToUpload;
      formData["pdf"] = base64PdfToUpload.base64;
      formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
      formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
      console.log('formData', formData);
      
    
      const transform={fields:{...formData}};
      delete transform.fields["pdfFile"];

     console.log('vremove',transform);
     console.log(transform);
           setIsLoading(true);
           prelimshallticket()
               .then(response => {
                  
                   setModalOtp(true);
                   setmodalOtpstatus(response.message);
                   window.grecaptcha.reset(setverified);
                   setverified(false);
                   setvaluephno(undefined);
                   document.getElementById("upschallticket").reset();
                   setIsLoading(false);
               })
               .catch(error => {
                setModalOtp(true);
                setmodalOtpstatus("failure");
                window.grecaptcha.reset(setverified);
                setverified(false);
                setIsLoading(false);
              })
    
        }
        else {
    
          setcaptchaerror(true);
          setTimeout(() => {
            setcaptchaerror(false);
          }, 3000);
        }
    
      }
  return (
    <>

      {isLoading &&
        <div class="APIPreLoader" id="APIPreLoader">
          <div class="loader">Loading...</div>
        </div>
      }
      <Otpverification show={modalOtp} title={modalOtpstatus} frompage="Upschallticketvalidation" onHide={() => setModalOtp(false)} />
      <div className="pt-3" style={{ background: "#FFF2F2 0% 0% no-repeat padding-box", opacity: "1" }}>

        <div className="container pt-3">
          <div className="row">
            <div className="">
             
              <p className={`${styles.acheiverrank1} mb-0`}>Registration for Moksha Orientation 11th June by (Ramakrishnasamy R Chennai) and (Sakthyakrishnan KP Delhi (Offline/Online))</p>
            </div>
          </div>

          <div className="row">

            <div className="">

              <form onSubmit={handleOnSubmit} id="upschallticket" autoComplete="off">

                <div className="row pt-4">

                  <div className="col-12 col-lg-4 col-xl-3">
                    <div className="mb-4">
                      <input type="text" className={`${styles.acheiverrank} form-control`} autoComplete="off" placeholder="Name" name="name" minLength="1" required />
                    </div>
                  </div>

                  <div className="col-12 col-lg-4 col-xl-3">
                    <div className="mb-4">
                      <input type="email" className={`${styles.acheiverrank} form-control`} placeholder="Email Address" title="Please enter a valid email address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                    </div>
                  </div>

                  <div className="col-12 col-lg-3">
                      <div className="mb-4">
                        <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
                      </div>
                    </div>
                 

                  <div className="col-12 col-lg-4 col-xl-3">
                    <div className="mb-4">
                      <input type="number" className={`${styles.acheiverrank} form-control`} placeholder="UPSC Roll no" title="Please enter a valid Roll no" autoComplete="off" minLength="15" name="rollNo" required></input>
                    </div>
                  </div>

                   <div className="col-12 col-lg-4 col-xl-4">
                    <div className="mb-4">
                      <p className="text-start mb-0"><label htmlFor="exampleInputPhno" className={`${styles.acheiverrank} form-label`}>Upload Hall Ticket<span className={`${styles.formstar}`}>*</span></label><span className={`${styles.attachment} mx-3`}>PDF format and less than 2MB</span></p>
                      <div className="input-group d-block">
                        <div className="form-group">
                          <div className="input-group">
                            <input type="text" id="selectpdf" name="filename" className="form-control" readOnly required return />
                            <span className="input-group-btn" style={{ border: "1px solid #D9DFE6", borderTopRightRadius: "0.375rem", borderBottomRightRadius: "0.375rem" }}>
                              <div className={`${styles.customFileUploader} btn btn-default`}>
                                <input type="file" className={`${styles.selected}`} title="Please fill out this field" name="pdffile" id="pdfid" onChange={e => pdfUpload(e)} accept="application/pdf" required />
                                Select File
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="">
                        {pdferror && <div className="text-danger pt-1 captachafont">Please select a file upto a size of 2 MB</div>}
                      </div>
                    </div>

                  </div>

                 

                  
                <div className="col-12 col-lg-4 col-xl-4">

                    <span className="form-check">
                    <span className="text-center">
                      <input className="form-check-input" type="checkbox" value="" id={styles.invalidCheck2} />
                      <label style={{ display: 'contents' }} className={`${styles.checkboxcontent} form-check-label`} htmlFor="invalidCheck2">
                        I would like to receive updates from Shankar IAS Academy
                      </label>
                    </span>
                  </span>
                  <div className="me-3 mt-2">
                    <ReCAPTCHA className={`${styles.captcha}`}
                      sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                      onChange={onChange}
                    />
                    <div className="">
                      {captchaerror && <div className="text-danger captachafont">Please verify the captcha!</div>}
                    </div>
                  </div>
                  </div>

               <div className="col-12 col-lg-4 col-xl-4">
                  <div className="mt-md-4">
                    <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p>
                  </div>
                </div>


                </div>

              

              </form>

            </div>

          </div>

        </div>

      </div>

    </>
  )
}
export default Upsc_Prelims_form;